/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-key */
import React, { FC, BaseSyntheticEvent, useEffect, useRef, useState } from 'react'
import { fetchWells } from './utils'
import i18n from 'live/services/i18n'
import LiveSelect from 'live/components/forms/ui/select'

interface SelectorProps extends AssetSelectorBaseProps {
    well?: any,
}

export const WellSelector: FC<SelectorProps> = ({ onChange, well, mode, label, placeholder, required, readOnly, validationState }) => {
    const [wells, setWells] = useState<any[]>([])
    const [selectedWell, setSelectedWell] = useState<any>(well)

    const selectWell = (e: BaseSyntheticEvent, data: unknown): void => {
        if (onChange) onChange(data)
        setSelectedWell(data)
    }

    const buildLabel = () => {
        return `${ label ?? i18n('Wells') } ${ required ? '*': '' }`
    }

    useEffect(() => {
        fetchWells().then(response => {
            const wells = response
                ? [
                    ...response.map(well => ({
                        value: well.name,
                        label: well.name,
                        data: {
                            id: well.id,
                            name: well.name
                        }
                    }))
                ]
                : []
            setWells(wells)
        })
    }, []);

    return (
        <>
            <LiveSelect
                clearable={true}
                label={buildLabel()}
                options={wells}
                disabled={readOnly || mode === 'readOnly'}
                onBlur={() => {}}
                onChange={selectWell}
                placeholder={placeholder ?? i18n('Select a well')}
                value={mode === 'edit' || mode === 'readOnly'? selectedWell : undefined}
                validationState={validationState}
            />
        </>
    )
}